export default __webpack_public_path__ + "static/media/fi_above_18.b2d5ed07.png";